import '@ungap/with-resolvers';
// eslint-disable-next-line perfectionist/sort-imports
import Keycloak from 'keycloak-js';

/**
 *
 */
export default defineNuxtPlugin(async () => {
    if (import.meta.env.STORYBOOK === 'true') {
        return {};
    }

    const runtimeConfig = useRuntimeConfig();
    const { isFeatureEnabled } = useFeatureFlags();
    const { createKeycloakRedirectUri } = useAuth();

    if (!isFeatureEnabled('login') || import.meta.env.TEST) {
        return {};
    }

    const fullPath = window.location.pathname + window.location.search;
    const redirectUri = createKeycloakRedirectUri(window.location.origin, fullPath);
    const silentCheckSsoRedirectUri = new URL('/silent-check-sso.html', window.location.origin).href;
    const keycloakConfig = {
        url: runtimeConfig.public.keycloak.authServerUrl,
        realm: runtimeConfig.public.keycloak.realm,
        clientId: runtimeConfig.public.keycloak.clientId,
    };
    let keycloak;
    try {
        keycloak = new Keycloak(keycloakConfig);
        await keycloak.init({
            onLoad: 'check-sso',
            silentCheckSsoRedirectUri,
            silentCheckSsoFallback: true,
            enableLogging: import.meta.dev,
            redirectUri,
        });
    }
    catch (error) {
        keycloak = undefined;
        logSilentSentryError(new Error('Keycloak initialization failed', { cause: error }), {
            ...keycloakConfig,
            silentCheckSsoRedirectUri,
        });
    }

    return {
        provide: {
            keycloak,
        },
    };
});
